<ngx-loading [show]="isSearchById"></ngx-loading>

<section>
  <datalist id="listfuncionarios">
    <select>
      <option *ngFor="let item of osCompleta?.possiveisColaboradores" [value]="item.nome"></option>
    </select>
  </datalist>

  <datalist id="listmateriais">
    <select>
      <option *ngFor="let item of osCompleta?.possiveisMateriais" [value]="item.descricao"></option>
    </select>
  </datalist>
</section>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-header text-center">
        <h3 class="box-title">{{ titulo }}</h3>
        <br />
      </div>

      <div class="box-body h650">
        <form novalidate [formGroup]="form" id="form" (ngSubmit)="buscar()">
          <div class="form-row">
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="osId">Nº OS</label>
                <div class="input-group">
                  <input type="text" class="form-control" formControlName="osid" maxlength="5" />
                  <div class="input-group-append cp" (click)="limparParametroOS()" title="Limpar">
                    <span class="input-group-text bg-light"><i class="fa fa-times"></i></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3" [hidden]="this.empreiteiras?.length == 1">
              <div class="position-relative form-group">
                <label for="empreiteiraId">Empreiteira</label>
                <select class="form-control" formControlName="empreiteiraId"
                  [ngClass]="{ 'h-error': validacaoEmpreiteira != '' }">
                  <option value="" *ngIf="this.empreiteiras?.length > 1">
                    selecione
                  </option>
                  <option *ngFor="let e of empreiteiras" [value]="e.id">
                    {{ e.nome }}
                  </option>
                </select>
                <span *ngIf="validacaoEmpreiteira != ''" class="text-danger">{{
                  this.validacaoEmpreiteira
                  }}</span>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="id">Dt. Emissão Inicial</label>
                <div class="input-group">
                  <input class="form-control" [ngClass]="{ 'h-error': this.validacaoDatas !== '' }" type="date"
                    formControlName="dataEmissaoInicial" max="2999-12-31"
                    (change)="isDatasEmissaoAmbasVaziasOuPreenchidas()" />
                  <div class="input-group-append">
                    <span class="input-group-text cp" (click)="limparDataEmissaoInicial()">X</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="requisitante">Dt. Emissão Final</label>
                <div class="input-group">
                  <input class="form-control" [ngClass]="{ 'h-error': this.validacaoDatas !== '' }" type="date"
                    formControlName="dataEmissaoFinal" max="2999-12-31"
                    (change)="isDatasEmissaoAmbasVaziasOuPreenchidas()" />
                  <div class="input-group-append">
                    <span class="input-group-text cp" (click)="limparDataEmissaoFinal()">X</span>
                  </div>
                </div>
                <div class="text-danger" *ngIf="
                    form.get('dataEmissaoFinal').hasError('dateLessThan') &&
                    form.get('dataEmissaoFinal').touched
                  ">
                  Data Final deve ser maior que a Data Inicial.
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-primary btn-block btn-bottom btn-shadow" (click)="buscar()">
                <i class="fa fa-search pull-left pt-1"></i>Buscar
              </button>
            </div>
          </div>
          <div class="form-row mb-1">
            <div class="col-md-10 text-center">
              <div class="text-danger fs11" *ngIf="this.validacaoDatas !== ''">
                {{ this.validacaoDatas }}
              </div>
            </div>
          </div>

          <div class="form-row mb-2">
            <div class="col-md-6">
              <div class="custom-checkbox custom-control checkbox-bottom" style="margin-top: 0">
                <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px"
                  formControlName="importadasMobilidade" />
                <label class="form-check-label" for="">Somente as importadas da Mobilidade
                </label>
              </div>
            </div>
          </div>
        </form>

        <section *ngIf="this.resultadosPesquisa?.length > 0" class="animated fadeInDown">
          <div class="box box-primary">
            <div class="box-header">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex justify-content-center">
                    <h3 class="box-title">Resultado da Pesquisa</h3>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <div class="box-body">
              <div class="box-table" style="height: 409px">
                <table style="font-size: 0.9em">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nº OS</th>
                      <th style="vertical-align: middle">Status</th>
                      <th>Serviço Solicitado</th>
                      <th>Serviço Executado</th>
                      <th>Data Execução</th>
                      <th>Data Emissão</th>
                      <th>Local</th>
                      <th>Área Técnica</th>
                      <th>Prioridade</th>
                      <th>Tipo de OS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of this.resultadosPesquisa">
                      <td class="text-center cp" title="OS Nº {{ item?.id | zerosEsquerda: 4 }}">
                        <button type="button" class="btn btn-sm" (click)="
                            getById(item?.id, item?.spvId, modalDetalhesSpv)
                          " (dblclick)="(return)" [disabled]="
                            this.isSearchById || !this.autorizacoes?.podeIncluir
                          ">
                          <i class="fa fa-lg fa-hand-o-right txt-blue"></i>
                        </button>
                      </td>
                      <td class="text-center cp w90">
                        {{ item?.id | zerosEsquerda: 5 }}
                      </td>
                      <td class="text-center">
                        <span class="badge badge-pill fw" [ngStyle]="{
                            'background-color': bgStatus[item?.status]
                          }">{{ item?.statusStr }}</span>
                      </td>
                      <td>{{ item?.servicoSolicitado }}</td>
                      <td>{{ item?.servicoRealizado }}</td>
                      <td>{{ item?.dataHoraFimExec | date: "dd/MM/yyyy" }}</td>
                      <td>{{ item?.dataHoraEmissao | date: "dd/MM/yyyy" }}</td>
                      <td class="text-center">{{ item?.local }}</td>
                      <td class="text-center">{{ item?.areaTecnica }}</td>
                      <td class="text-center">{{ item.prioridadeStr }}</td>
                      <td class="text-center">{{ item?.tipoOSStr }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="box-footer">
              <span *ngIf="this.resultadosPesquisa?.length == 0" class="pl-2 pt-1 pb-2"><b>Nenhum OS
                  encontrada</b></span>
              <span *ngIf="this.resultadosPesquisa?.length > 0" class="pl-2 pt-1 pb-2">Total de OSs encontradas :
                <b>{{ this.resultadosPesquisa?.length }}</b></span>
              <app-ball-pulse *ngIf="imprimindoOS" class="pull-right"></app-ball-pulse>
            </div>
          </div>
        </section>
        <section class="mt-5">
          <app-ball-pulse *ngIf="this.isProcessing"></app-ball-pulse>
        </section>

        <section *ngIf="
            this.resultadosPesquisa?.length == 0 && nenhumResultado == true
          " class="animated fadeInDown h300 text-center" style="margin-top: 70px">
          <div class="row">
            <div class="col-md-12">
              <img src="./assets/images/no-result2.png" />
            </div>
            <div class="col-md-12">
              <h6>Nenhum resultado foi encontrado</h6>
            </div>
            <div class="col-md-12">
              <h6>com os parâmetros fornecidos</h6>
            </div>
          </div>
        </section>

        <ng-template #modalquestion let-c="close" let-d="dismiss">
          <div class="modal-header">
            <h4 class="modal-title">SIGEM CLOUD</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-3">
                <div class="d-flex justify-content-center">
                  <img src="assets\images\icon-question.png" />
                </div>
              </div>
              <div class="col-md-9">
                <div class="alert alert-info">
                  <div class="d-flex justify-content-center">
                    <span *ngIf="this.totalSpvsSelecionados == 1" class="question-modal">Será gerada <b>uma</b>
                      OS</span>
                    <span *ngIf="this.totalSpvsSelecionados > 1" class="question-modal">Serão geradas
                      <b>{{ this.totalSpvsSelecionados }}</b> OSs.</span>
                  </div>
                  <div class="d-flex justify-content-center">
                    <span class="question-modal pt-2 pb-2"><b>Deseja continuar?</b></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <div class="d-flex justify-content-end">
                  <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">
                    Não
                  </button>
                  <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2" (click)="gerarOSs()">
                    Sim
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #modalDetalhesSpv let-c="close" let-d="dismiss">
          <div class="modal-header">
            <h4 class="modal-title">
              <span *ngIf="tipoAcaoOS == 1">Fechamento OS Nº</span>
              <span *ngIf="tipoAcaoOS == 2">Dar Visto de Execução - OS Nº</span>
              <span *ngIf="tipoAcaoOS == 3">Validar OS Nº</span>
              <b><span>{{ osCompleta?.osId | zerosEsquerda: 5 }}</span></b>
              <i *ngIf="this.isProcessing" class="fa fa-spinner fa-spin fa-fw pull-right mt-1"></i>
            </h4>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="bx-tb-detalhes pre-scrollable h650">
                  <table class="table table-bordered tb-detalhes">
                    <thead style="border-collapse: collapse; border-spacing: 0">
                      <td style="width: 20%"></td>
                      <td style="width: 30%"></td>
                      <td style="width: 20%"></td>
                      <td style="width: 25%"></td>
                      <td style="width: 5%"></td>
                    </thead>
                    <tbody>
                      <tr>
                        <th colspan="5" class="text-center title">Cadastro</th>
                      </tr>

                      <tr>
                        <th>Data Hora do Cadastro</th>
                        <td>
                          {{
                          osCompleta?.spvCompleto.dataHoraCadastro
                          | date: "dd/MM/yyyy HH:mm"
                          }}
                        </td>
                        <th>Usuário Solicitante</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.usuarioSolicitante }}
                        </td>
                      </tr>

                      <tr>
                        <th>Requisitante</th>
                        <td>{{ osCompleta?.spvCompleto.requisitante }}</td>
                        <th>Ramal</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.contato }}
                        </td>
                      </tr>

                      <tr>
                        <th>Serviço</th>
                        <td colspan="4">
                          {{ osCompleta?.spvCompleto.servico }}
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <th>Status Atual</th>
                        <td>{{ osCompleta?.spvCompleto.statusStr }}</td>
                        <th>Data Status</th>
                        <td colspan="2">
                          {{
                          osCompleta?.spvCompleto.dataStatus
                          | date: "dd/MM/yyyy"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>{{ labelCentroCusto }}</th>
                        <td colspan="4">
                          {{ osCompleta?.spvCompleto.centroCusto }}
                        </td>
                      </tr>

                      <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                        <th colspan="5" class="text-center title">
                          Aprovação/Qualificação
                        </th>
                      </tr>
                      <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                        <th>Data Aprovação</th>
                        <td>
                          {{
                          osCompleta?.spvCompleto.dataHoraAprovacao
                          | date: "dd/MM/yyyy"
                          }}
                        </td>
                        <th>Aprovado por</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.aprovadoPor }}
                        </td>
                      </tr>
                      <tr *ngIf="osCompleta?.spvCompleto.spvAprovadoId != null">
                        <th>Qualificado por</th>
                        <td>{{ osCompleta?.spvCompleto.qualificadoPor }}</td>
                        <th>Prioridade</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.prioridadeStr }}
                        </td>
                      </tr>
                      <tr *ngIf="osCompleta?.spvCompleto.ptId != null">
                        <th>Data Aprovação</th>
                        <td>
                          {{
                          osCompleta?.spvCompleto.dataHoraAprovacao
                          | date: "dd/MM/yyyy"
                          }}
                        </td>
                        <th>Prioridade</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.prioridadeStr }}
                        </td>
                      </tr>
                      <tr>
                        <th>Observações Gerais</th>
                        <td colspan="4">
                          {{ osCompleta?.spvCompleto.observacoesGerais }}
                        </td>
                      </tr>
                      <tr>
                        <th>Área restrita</th>
                        <td>{{ osCompleta?.spvCompleto.areaRestritaStr }}</td>
                        <th>Fim de Semana</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.fimDeSemanaStr }}
                        </td>
                      </tr>
                      <tr>
                        <th>Engenheiro Responsável</th>
                        <td>
                          {{
                          osCompleta?.spvCompleto.engenheiroResponsavel == ""
                          ? " - "
                          : osCompleta?.spvCompleto.engenheiroResponsavel
                          }}
                        </td>
                        <th>Responsável OS</th>
                        <td colspan="2">
                          {{
                          osCompleta?.spvCompleto.encarregadoResponsavel ==
                          null
                          ? " - "
                          : osCompleta?.spvCompleto.encarregadoResponsavel
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Área Técnica</th>
                        <td>{{ osCompleta?.spvCompleto.areaTecnica }}</td>
                        <th>Prédio</th>
                        <td colspan="2">
                          {{ osCompleta?.spvCompleto.predio }}
                        </td>
                      </tr>
                      <tr>
                        <th>Equipamento</th>
                        <td>{{ osCompleta?.spvCompleto.equipamento }}</td>
                        <th>Empreiteira</th>
                        <td colspan="3">
                          {{ osCompleta?.spvCompleto.empreiteira }}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="5" style="background-color: #f39c12; padding: 1px"></td>
                      </tr>
                      <tr>
                        <th colspan="4" class="text-center title">
                          Colaboradores
                        </th>
                        <td class="text-center bg-primary cp" (click)="openModalColaboradores(modalcolaboradores)"
                          title="Adicionar novo Colaborador">
                          <span><i class="fwn fa fa-plus"></i></span>
                        </td>
                      </tr>

                      <tr *ngFor="let c of osCompleta?.spvCompleto?.colaboradores">
                        <td class="text-center">{{ c?.nome }}</td>
                        <td class="text-center">{{ c?.matricula }}</td>
                        <td class="text-center">
                          {{ c?.dataHoraInicio | date: "dd/MM/yyyy HH:mm" }}
                        </td>
                        <td colspan="2" class="text-center">
                          {{ c?.dataHoraFim | date: "dd/MM/yyyy HH:mm" }}
                        </td>
                      </tr>
                      <!-- <tr *ngIf="this.validacoes.datasColaboradoresOK == false">
                        <td colspan="2"></td>
                        <td colspan="3" class="text-center">
                          <span class="txt-danger-fb text-center">Nem todas as datas Início e fim dos colaboradores
                            foram informadas</span>
                        </td>

                      </tr> -->
                      <tr *ngIf="
                          osCompleta?.spvCompleto?.colaboradores?.length == 0 ||
                          this.osCompleta?.tipoOSFilha == 1
                        ">
                        <th colspan="5" class="text-center">Não informado</th>
                      </tr>

                      <tr>
                        <th colspan="5" class="text-center title">
                          Dados da realização
                        </th>
                      </tr>
                      <tr>
                        <th>Data/Hora Inicio</th>
                        <td class="sem-borda">
                          <input type="datetime-local" class="form-control fb" tabindex="1" [value]="
                              osCompleta?.dataHoraInicioExec
                                | date: 'yyyy-MM-dd HH:mm'
                            " id="dataHoraInicioExec" [ngClass]="{
                              'h-error':
                                this.validacoes.dataHoraInicioExec != ''
                            }" (change)="validaDadosRealizacao()" max="9999-12-31T23:59:59"
                            [readOnly]="tipoAcaoOS != 2" />
                          <span *ngIf="this.validacoes.dataHoraInicioExec != ''" class="txt-danger">{{
                            this.validacoes.dataHoraInicioExec }}</span>
                        </td>
                        <th class="sem-borda">Data/Hora Fim</th>
                        <td colspan="2">
                          <input type="datetime-local" class="form-control fb" tabindex="2" [value]="
                              osCompleta?.dataHoraFimExec
                                | date: 'yyyy-MM-dd HH:mm'
                            " id="dataHoraFimExec" [ngClass]="{
                              'h-error': this.validacoes.dataHoraFimExec != ''
                            }" (change)="validaDadosRealizacao()" max="9999-12-31T23:59:59"
                            [readOnly]="tipoAcaoOS != 2" />
                          <span *ngIf="this.validacoes.dataHoraFimExec != ''" class="txt-danger">{{
                            this.validacoes.dataHoraFimExec }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>Serviço Realizado {{ tipoAcaoOS }}</th>
                        <td colspan="4">
                          <textarea row="2" class="form-control" [value]="osCompleta?.servicoRealizado" tabindex="3"
                            id="servicoRealizado" [ngClass]="{
                              'h-error': this.validacoes.servicoRealizado != ''
                            }" (change)="validaDadosRealizacao()" [readOnly]="tipoAcaoOS != 2">
                          </textarea>
                          <span *ngIf="this.validacoes.servicoRealizado != ''" class="txt-danger">{{
                            this.validacoes.servicoRealizado }}</span>
                        </td>
                      </tr>
                      <tr *ngIf="tipoAcaoOS == 3">
                        <th colspan="5" class="text-center title">
                          Avaliação do Serviço
                        </th>
                      </tr>

                      <tr *ngIf="tipoAcaoOS == 3">
                        <th class="sem-borda">Cliente</th>
                        <td>
                          <input type="text" class="form-control fb" [(ngModel)]="osCompleta.cliente" tabindex="4"
                            maxlength="50" id="cliente" [readOnly]="osCompleta?.codigoExportacao != Null" [ngClass]="{
                              'h-error': this.validacoes.cliente != ''
                            }" (change)="validaDadosRealizacao()" />
                          <span *ngIf="this.validacoes.cliente != ''" class="txt-danger">{{ this.validacoes.cliente
                            }}</span>
                        </td>
                        <th>Matrícula</th>
                        <td colspan="2">
                          <input type="text" class="form-control fb" [(ngModel)]="osCompleta.matricula" tabindex="5"
                            [readOnly]="osCompleta?.codigoExportacao != Null" maxlength="20" id="matricula" />
                        </td>
                      </tr>
                      <tr *ngIf="tipoAcaoOS == 3">
                        <th>Setor</th>
                        <td>
                          <input type="text" class="form-control fb" [(ngModel)]="osCompleta.setor" tabindex="6"
                            [readOnly]="osCompleta?.codigoExportacao != Null" maxlength="30" id="setor" />
                        </td>
                        <th class="sem-borda">Satisfeito</th>
                        <td>
                          <select class="form-control fb" [(ngModel)]="osCompleta.satisfeito" name="satisfeito"
                            tabindex="6" maxlength="50" id="satisfeito"
                            [disabled]="osCompleta?.codigoExportacao != Null" 
                            [ngClass]="{'h-error': this.validacoes.satisfeito != ''}" 
                            (change)="validaDadosRealizacao()">
                            <option [ngValue]="0">Não informado</option>
                            <option [ngValue]="1">Excelente</option>
                            <option [ngValue]="2">Muito bom</option>
                            <option [ngValue]="3">Bom</option>
                            <option [ngValue]="4">Ruim</option>
                            <option [ngValue]="5">Muito ruim</option>
                          </select>
                          <span *ngIf="this.validacoes.satisfeito != ''" class="txt-danger">{{
                            this.validacoes.satisfeito }}</span>
                        </td>
                        <td class="sem-borda text-center">
                          <img src="./assets/images/{{imagens_satisfacao[osCompleta?.satisfeito]}}" 
                          style="width: 65%" />
                        </td>
                      </tr>
                      <tr *ngIf="tipoAcaoOS == 1">
                        <th>Observação execução</th>
                        <td colspan="4">
                          <textarea row="2" class="form-control" [(ngModel)]="osCompleta.observacaoExecucao"
                            tabindex="8" id="observacaoExecucao" 
                            [ngClass]="{'h-error': this.validacoes.observacaoExecucao != ''}" 
                            (change)="validaDadosRealizacao()">
                          </textarea>
                          <span *ngIf="this.validacoes.observacaoExecucao != ''" class="txt-danger">{{
                            this.validacoes.observacaoExecucao }}</span>
                        </td>
                      </tr>

                      <tr *ngIf="tipoAcaoOS == 3">
                        <th>Observação sobre a avaliação</th>
                        <td colspan="4">
                          <textarea row="2" class="form-control" [(ngModel)]="osCompleta.observacaoAvaliacao"
                            tabindex="8" id="observacaoAvaliacao" 
                            [ngClass]="{'h-error': this.validacoes.observacaoAvaliacao != ''}" 
                            (change)="validaDadosRealizacao()">
                          </textarea>
                          <span *ngIf="this.validacoes.observacaoAvaliacao != ''" class="txt-danger">{{
                            this.validacoes.observacaoAvaliacao }}</span>
                        </td>
                      </tr>

                      <tr>
                        <th colspan="4" class="text-center title">
                          Irregularidades
                        </th>
                        <td class="text-center bg-primary cp" (click)="
                            openModalIrregularidades(modalirregularidades)
                          " title="Adicionar nova Irregularidade">
                          <span><i class="fwn fa fa-plus"></i></span>
                        </td>
                      </tr>

                      <tr>
                        <th class="text-center">Tipo Irregularidade</th>
                        <th colspan="4" class="text-center">Descrição</th>
                      </tr>

                      <tr *ngFor="let i of osCompleta.irregularidades">
                        <td class="text-center">{{ i.tipoIrregularidade }}</td>
                        <td colspan="4">{{ i.descricao }}</td>
                      </tr>
                      <tr *ngIf="osCompleta?.irregularidades.length == 0">
                        <th colspan="5" class="text-center">Não informado</th>
                      </tr>

                      <tr>
                        <th colspan="4" class="text-center title">Materiais</th>
                        <td class="text-center bg-primary cp" (click)="openModalMateriais(modalMateriais)"
                          title="Adicionar novo material">
                          <span><i class="fwn fa fa-plus"></i></span>
                        </td>
                      </tr>

                      <tr>
                        <th class="text-center">Código</th>
                        <th colspan="2" class="text-center">Material</th>
                        <th class="text-center">Quantidade</th>
                        <th class="text-center">Unidade</th>
                      </tr>

                      <tr *ngFor="let item of osCompleta.materiaisUsado">
                        <td class="text-center">{{ item.codigo }}</td>
                        <td colspan="2">{{ item.descricao }}</td>
                        <td class="text-center">{{ item.quantidade }}</td>
                        <td class="text-center">{{ item.unidade }}</td>
                      </tr>
                      <tr *ngIf="osCompleta?.materiaisUsado.length == 0">
                        <th colspan="5" class="text-center">Não informado</th>
                      </tr>
                    </tbody>
                  </table>

                  <!--  Registros fotográficos (ANTES)-->
                  <section style="border-top: 2px solid #f39c12; margin-top: 15px">
                    <div class="form-row text-center" style="padding: 0 5px">
                      <div class="col-md-11 fb fs11" 
                      [ngClass]="{'col-md-12': !this.autorizacaoAdicionarFoto, 'col-md-11': this.autorizacaoAdicionarFoto}" 
                          style="background-color: #eee; padding: 12px">
                        <span class="txt-blue">
                          Registro fotográfico (Antes)
                        </span>
                      </div>
                      <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
                        (click)="fileInputAntes.click()" *ngIf="this.autorizacaoAdicionarFoto">
                        <span><i class="fwn fa fa-plus"></i></span>
                      </div>
                    </div>

                    <div class="row" *ngIf="previewsPhotosAntes?.length > 0"
                      style="padding-bottom: 20px; min-height: 100px">
                      <div class="col-md-2" *ngFor="let pview of previewsPhotosAntes">
                        <div>
                          <img [src]="pview.dataUrl" class="zoom cp" (click)="
                              openModalExibePhoto(modalExibePhoto, pview)
                            " />
                        </div>
                        <button type="button" class="btn btn-default" *ngIf="this.autorizacaoAdicionarFoto">
                          <i class="fa fa-trash text-secoundary" (click)="removerPhotoAntes(pview.name)"
                            title="Remover esta foto"></i>
                        </button>
                      </div>
                    </div>

                    <div *ngIf="previewsPhotosAntes?.length == 0" class="text-center"
                      style="margin-top: 50px; margin-bottom: 50px">
                      <span>Nenhum registro fotográfico antes</span>
                    </div>
                  </section>

                  <!--  Registros fotográficos (DEPOIS)-->

                  <section style="border-top: 2px solid #f39c12; margin-top: 15px">
                    <div class="form-row text-center" style="padding: 0 5px">
                      <div class="fb fs11 col-md-11" style="background-color: #eee; padding: 12px">
                        <span class="txt-blue">
                          Registro fotográfico (Depois)
                        </span>
                      </div>

                      <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
                        (click)="fileInput.click()">
                        <span><i class="fwn fa fa-plus"></i></span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-2" *ngFor="let pview of previewsPhotos">
                        <div>
                          <img [src]="pview.dataUrl" class="zoom cp" (click)="
                              openModalExibePhoto(modalExibePhoto, pview)
                            " />
                          <button type="button" class="btn btn-default">
                            <i class="fa fa-trash text-secoundary" (click)="removerPhoto(pview.name)"
                              title="Remover esta foto"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="previewsPhotos?.length == 0" class="text-center"
                      style="margin-top: 50px; margin-bottom: 50px">
                      <span>Nenhum registro fotográfico depois</span>
                    </div>
                  </section>
                </div>
              </div>
            </div>

            <app-log-avaliacao *ngIf="showModalLogAvaliacao" [shouldOpenModal]="showModalLogAvaliacao"
              [inputOSId]="osCompleta?.osId" (changeShowModal)="changeShowModal()"></app-log-avaliacao>
          </div>

          <div class="modal-footer pl-5">
            <div class="col-md-2">
              <button type="button" class="btn btn-danger btn-block" (click)="submit(c, 4)"
                [disabled]="this.isProcessing" *ngIf="tipoAcaoOS == 1">
                Cancelar OS
              </button>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-danger btn-block" (click)="submit(c, 2)"
                [disabled]="this.isProcessing" *ngIf="tipoAcaoOS == 1">
                OS Não Executada
              </button>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-danger btn-block" (click)="submit(c, 6)"
                [disabled]="this.isProcessing" *ngIf="tipoAcaoOS == 3">
                OS Reprovada
              </button>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-info btn-block" (click)="setShowModalLogAvaliacao()"
                *ngIf="tipoAcaoOS == 1 || tipoAcaoOS == 3">
                Logs de Avaliação
              </button>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-primary btn-block" (click)="submit(c, 99)"
                [disabled]="this.isProcessing">
                <span *ngIf="tipoAcaoOS == 1">Fechar OS</span>
                <span *ngIf="tipoAcaoOS == 2">Dar Visto de Execução</span>
                <span *ngIf="tipoAcaoOS == 3">OS Validada</span>
              </button>
            </div>

            <div class="col-md-2">
              <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">
                Desistir
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<form novalidate [formGroup]="photoForm" class="row">
  <input hidden #fileInput formControlName="photo" type="file" accept="image/*" multiple
    (change)="handleFile($event.target.files)" />

  <input hidden #fileInputAntes formControlName="photoAntes" type="file" accept="image/*" multiple
    (change)="handleFileFotoAntes($event.target.files)" />
</form>

<ng-template #modalcolaboradores let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Informar Colaboradores</h4>
  </div>

  <div class="modal-body pl-5 pr-5 pb-0">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="offset-md-3 col-md-6">
            <div class="text-center">
              <span class="text-muted fs09"><i class="fa fa-search"></i> Pesquisa por
                <b>parte do nome</b> ou <b>matrícula</b> do funcionário</span>
            </div>
            <div class="input-group mt-3">
              <input type="text" class="form-control" list="listfuncionarios" id="datalistFuncionarios"
                (change)="changeDataListFuncionarios($event.target.value)" maxlength="90" />
              <div class="input-group-append cp" (click)="limparDataListFuncionarios()"
                title="limpar campo e recarregar lista completa de opções">
                <span class="input-group-text"><i class="fa fa-trash"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- row 1 col 2 -->
          <div class="offset-md-3 col-md-6">
            <div class="text-center mb-2">
              <span class="text-muted">Selecione um ou mais na lista e clique em adicionar</span>
            </div>
            <div class="box-table-sm fs09" style="height: 120px">
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Matrícula</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let f of this.possiveisColaboradoresListaGrid" (click)="selectColaborador(f.id)"
                    class="alert cp" [ngClass]="{ 'tr-info': f.marcado }">
                    <td>{{ f.nome }}</td>
                    <td class="text-center" tabindex="20">{{ f.matricula }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row mt-2">
              <!-- row 2 -->
              <div class="col-md-8">
                <div class="d-flex justify-content-start mt-2">
                  <span *ngIf="
                      this.possiveisColaboradoresListaGrid.length <
                      osCompleta?.possiveisColaboradores.length
                    ">
                    Total funcionários (filtrados) :
                  </span>
                  <span *ngIf="
                      this.possiveisColaboradoresListaGrid.length ==
                      osCompleta?.possiveisColaboradores.length
                    ">
                    Total funcionários :
                  </span>
                  <span><b>{{
                      this.possiveisColaboradoresListaGrid.length
                      }}</b></span>
                </div>
              </div>
              <div class="col-md-4 text-center">
                <button class="btn btn-block btn-info" (click)="adicionarColaboradores()"
                  title="Confirmar colaboradores selecionados" tabindex="21">
                  Adicionar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="box-table fs09" style="height: 240px">
              <table>
                <thead>
                  <tr>
                    <th colspan="5">
                      <b>Lista de colaboradores informados</b>
                      <span *ngIf=" this.osCompleta?.spvCompleto?.colaboradores?.length > 0"
                         class="badge badge-pill badge-warning pull-right pt-1">{{
                        osCompleta?.spvCompleto?.colaboradores?.length }}
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th class="wf250">Nome</th>
                    <th>Matrícula</th>
                    <th>Data/Hora inicial</th>
                    <th>Data/Hora final</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                      let f of osCompleta?.spvCompleto?.colaboradores;
                      let i = index
                    ">
                    <td>{{ f.nome }}</td>
                    <td class="text-center">{{ f.matricula }}</td>

                    <td>
                      <div class="input-group">
                        <input type="datetime-local" id="data-hi-colaborador{{ i }}" class="form-control" tabindex="22"
                          [value]="f.dataHoraInicio | date: 'yyyy-MM-dd HH:mm'" max="9999-12-31T23:59:59" />

                        <div class="input-group-append cp" (click)="clearInputDataHiColaborador('data-hi-colaborador', i)" 
                        title="limpar">
                          <span class="input-group-text"><i class="fa fa-times"></i></span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="input-group">
                        <input type="datetime-local" id="data-hf-colaborador{{ i }}" class="form-control" tabindex="22"
                          [value]="f.dataHoraFim | date: 'yyyy-MM-dd HH:mm'" max="9999-12-31T23:59:59" />

                        <div class="input-group-append cp" (click)="
                            clearInputDataHiColaborador(
                              'data-hf-colaborador',
                              i
                            )
                          " title="limpar">
                          <span class="input-group-text"><i class="fa fa-times"></i></span>
                        </div>
                      </div>
                    </td>

                    <td class="text-center">
                      <button class="btn btn-sm" (click)="removerColaborador(i)" title="remover da lista" tabindex="24">
                        <i class="fa fa-trash text-secoundary"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer mt-2">
    <div class="col-md-6 d-flex justify-content-start"></div>
    <div class="col-md-6">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="confirmarColaboradores(c)">
          {{
          osCompleta?.spvCompleto?.colaboradores?.length > 0
          ? "Confirmar"
          : "Fechar"
          }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalirregularidades let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Informar Irregularidades</h4>
  </div>

  <div class="modal-body pl-5 pr-5 pb-0">
    <div class="row">
      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue fb">Irregularidades disponíveis</span><br />
          <span class="text-muted">Selecione uma ou mais na lista e confirme</span>
        </div>
        <div class="divider"></div>
        <div class="box-table fs09" style="height: 327px">
          <table>
            <thead>
              <tr>
                <th style="width: 180px">Tipo Irregularidade</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of osCompleta?.possiveisIrregularidades" (click)="selectIrregularidade(i.id)"
                class="alert cp" [ngClass]="{ 'tr-info': i.marcado }">
                <td class="text-center">{{ i.tipoIrregularidade }}</td>
                <td class="text-left">{{ i.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-2 text-center">
        <button class="btn cp" (click)="adicionarIrregularidades()" style="margin-top: 180px"
          title="Confirmar Irregularidade selecionada">
          <img src="./assets/images/arrow-right.png" /></button><br />
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>

      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue fb">Irregularidades inseridas na atual OS</span><br />
        </div>
        <div class="divider"></div>

        <div class="box-table h350 fs09">
          <table>
            <thead>
              <tr>
                <th style="width: 150px">Tipo Irregularidade</th>
                <th>Descrição</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of osCompleta?.irregularidades">
                <td class="text-center">{{ i.tipoIrregularidade }}</td>
                <td class="text-left">{{ i.descricao }}</td>

                <td class="text-center">
                  <button class="btn btn-sm" (click)="removerIrregularidade(i)" title="remover da lista">
                    <i class="fa fa-trash text-secoundary"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mt-2">Total irregularidades informadas :
            <b>{{ osCompleta?.irregularidades?.length }}</b>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-2">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">
            {{
            osCompleta?.irregularidades?.length > 0 ? "Confirmar" : "Fechar"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalMateriais let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Informar Materiais</h4>
  </div>

  <div class="modal-body h650 pl-5 pr-5">
    <div class="row">
      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue db">Materiais disponíveis</span>
        </div>
        <div class="divider"></div>
        <div class="text-center">
          <span class="text-muted fs09"><i class="fa fa-search"></i> Pesquisa por <b>parte do código</b>,
            <b>descrição</b> ou <b>tipo material</b></span>
        </div>
        <div class="input-group mt-3">
          <input type="text" class="form-control" list="listmateriais" id="datalistMateriais"
            (change)="changeDataListMateriais($event.target.value)" maxlength="200" tabindex="30" />
          <div class="input-group-append cp" (click)="limparDataListMateriais()"
            title="limpar campo e recarregar lista completa de opções">
            <span class="input-group-text"><i class="fa fa-trash"></i></span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="text-center mb-2">
          <span class="text-muted">Selecione um ou mais na lista, informe as quantidades e
            confirme</span>
        </div>

        <div class="box-table-sm fs09" style="height: 350px">
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Unidade</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let item of this.possiveisMateriaisListaGrid;
                  let i = index
                " class="alert cp" [ngClass]="{ 'tr-info': item.marcado }">
                <td class="text-center" (click)="selectMateriais(item.materialId)">
                  {{ item.codigo }}
                </td>
                <td class="text-center" (click)="selectMateriais(item.materialId)">
                  {{ item.descricao }}
                </td>
                <td class="text-center">
                  <input [id]="item.materialId" type="number" class="form-control" min="1" (change)="
                      changeQuantidade(item.materialId, $event.target.value)
                    " tabindex="31" [value]="item.quantidade" (keyup.enter)="addMaterial(i, item.materialId)" />
                  <span *ngIf="item.touched && item.quantidade == 0 && item.marcado" class="text-danger">Campo
                    obrigatório.</span>
                </td>
                <td class="text-center" (click)="selectMateriais(item.materialId)">
                  {{ item.unidade }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start mt-2">
          <span *ngIf="
              this.possiveisMateriaisListaGrid.length <
              osCompleta?.possiveisMateriais.length
            ">
            Total materiais (filtrados) :
          </span>
          <span *ngIf="
              this.possiveisMateriaisListaGrid.length ==
              osCompleta?.possiveisMateriais.length
            ">
            Total materiais :
          </span>
          <span><b>{{
              this.possiveisMateriaisListaGrid.length | zerosEsquerda: 3
              }}</b></span>
        </div>
      </div>

      <div class="col-md-2 text-center">
        <button class="btn cp" (click)="adicionarMateriais()" style="margin-top: 270px"
          title="Confirmar material selecionado" tabindex="32">
          <img src="./assets/images/arrow-right.png" /></button><br />
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>

      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue db">Materiais inseridos na atual OS</span>
        </div>
        <div class="divider"></div>

        <div class="box-table fs09" style="height: 490px">
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Unidade</th>
                <th class="wf20"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of osCompleta?.materiaisUsado">
                <td class="text-center">{{ item.codigo }}</td>
                <td class="text-center">{{ item.descricao }}</td>
                <td class="text-center">{{ item.quantidade }}</td>
                <td class="text-center">{{ item.unidade }}</td>

                <td class="text-center">
                  <button class="btn btn-sm" (click)="removerMateriais(item)" title="remover da lista">
                    <i class="fa fa-trash text-secoundary"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mt-2">Total de materiais informados:
            <b>{{ osCompleta?.materiaisUsado?.length }}</b>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-2">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')" tabindex="33">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518">
    <div class="row">
      <div class="col-md-12 text-center" style="padding: 10px; background: #141518">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding: 10px; background: #141518">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">
          Fechar
        </button>
      </div>
    </div>
  </div>
</ng-template>